import { apiRequest } from "@/api/request";
import { ITenant } from "@/types/tenant";

const getTenants = () => {
    return apiRequest<ITenant[]>("/tenant", "GET");
};

const getUserTenant = () => {
    return apiRequest<ITenant>("/tenant/me", "GET");
};

const identifyTenant = (override?: string) => {
    const queryParams = override ? `?override=${override}` : "";
    return apiRequest<ITenant>(`/tenant/identify${queryParams}`, "GET");
};

const getTenant = (tenantId: string) => {
    return apiRequest<ITenant>(`/tenant/${tenantId}`, "GET");
};

const createTenant = (tenant: ITenant) => {
    return apiRequest<ITenant>("/tenant", "POST", tenant);
};

const updateTenant = (tenantId: string, tenant: ITenant) => {
    return apiRequest<ITenant>(`/tenant/${tenantId}`, "PUT", tenant);
};

export default {
    getTenants,
    getUserTenant,
    getTenant,
    createTenant,
    updateTenant,
    identifyTenant,
};
